import DataTable from '@/containers/data_table_ml/DataTable';
import { fieldPackageStatus } from '@/constants.js';
import Action from '../action/Action';
import { useState } from 'react';
import { history } from 'umi';
const TablePage = (props) => {
  const { loadingstatus, tableData, fetchData } = props || {};
  const [tableOption, setTableOption] = useState({});

  const getTableOption = (e) => {
    setTableOption(e);
  };
  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 80,
      align: 'center',
    },
    // {
    //   title: '字段包名',
    //   dataIndex: 'fieldPackageName',
    //   key: 'fieldPackageName',
    //   width: 200,
    // },
    {
      title: '字段名称',
      dataIndex: 'fieldName',
      key: 'fieldName',
      width: 200,
    },
    {
      title: '变量名',
      dataIndex: 'variableName',
      key: 'variableName',
      width: 130,
    },
    {
      title: '字段模型',
      dataIndex: 'fieldModelId',
      key: 'fieldModelId',
      width: 200,
      render: (text) => {
        for (const key in tableOption) {
          if (text && text.toString() === key.substring(1)) {
            return tableOption[key];
          }
        }
      },
    },
    {
      title: '字段格式',
      dataIndex: 'fieldType',
      key: 'fieldType',
      width: 100,
    },
    {
      title: '默认值',
      dataIndex: 'defaultValue',
      key: 'defaultValue',
      width: 70,
    },
    {
      title: '异常值',
      dataIndex: 'exceptionValue',
      key: 'exceptionValue',
      width: 70,
    },
    {
      title: '描述',
      dataIndex: 'description',
      key: 'description',
      width: 200,
    },
    {
      title: '状态',
      dataIndex: 'fieldStatus',
      key: 'fieldStatus',
      width: 70,
      render: (text) => {
        return fieldPackageStatus[text];
      },
    },
    // {
    //   title: '创建时间',
    //   dataIndex: 'createTime',
    //   key: 'createTime',
    //   width: 200,
    // },
    {
      title: '最后更新时间',
      dataIndex: 'updateTime',
      key: 'updateTime',
      width: 200,
    },
    {
      title: '操作',
      // fixed: 'right',
      render: (record) => {
        return (
          <Action
            singleListInfo={record}
            fetchData={fetchData}
            getTableOption={getTableOption}
          />
        );
      },
      width: 185,
    },
  ];
  return (
    <DataTable
      className="demo-test"
      columns={columns}
      rowSelection={false}
      scroll={{ y: 'calc(100vh - 64px - 46px - 47px - 68px - 3rem)', x: 1500 }}
      loading={loadingstatus}
      dataSource={tableData}
      title={() => (
        <div className="rule_name">
          <span>字段包名 {history.location.query.name}</span>
        </div>
      )}
      style={{
        border: '1px solid #edf0f0',
        marginTop: '1rem',
      }}
    />
  );
};
export default TablePage;
